import { ComponentProps } from 'react';
import { cx } from '@libs/classnames';
import styles from './LandingLink.module.css';

type Props = ComponentProps<'a'> & {
  chevron?: boolean;
};

export function LandingLink({ className, children, chevron, ...rest }: Props) {
  return (
    <a className={cx(styles.root, className)} {...rest}>
      {children}
      {chevron ? <>&nbsp;›</> : null}
    </a>
  );
}
